module.exports = "/images/featured-revised-example.jpg?79029992f8523f86c7cf634838e2901c";